import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../hook/useSettingsContext";

export default function QuantityInput({
    className = "input-text qty text",
    ...props
}) {
    const { previewOptions, quantity, handleQtyInputChange, getOption } =
        useSettingsContext();
    const allowDecimal = getOption("allowDecimal", "quantity");

    const handleChange = (e) => {
        let newValue = e.target.value;

        // If decimals are not allowed, remove decimal points
        if (!allowDecimal && newValue !== "") {
            newValue = newValue.split(".")[0];
        }

        // Call the original handler with modified event
        handleQtyInputChange({
            ...e,
            target: { ...e.target, value: newValue },
        });
    };

    return (
        <input
            type="number"
            className={className}
            name="quantity"
            value={quantity}
            min={previewOptions.minValue}
            max={previewOptions.maxValue || undefined}
            step={allowDecimal ? previewOptions.step : 1}
            onChange={handleChange}
            onKeyPress={(e) => {
                // Prevent decimal point if not allowed
                if (!allowDecimal && (e.key === "." || e.key === ",")) {
                    e.preventDefault();
                }
            }}
            inputMode="numeric"
            title={__("Qty", "wpbean-quantity-controls-for-woocommerce")}
            {...props}
        />
    );
}
